import React, { useState, useEffect, useRef } from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import Input from 'components/Input';
import ModalGeneralSuccessfully from 'screens/ModalGeneralSuccessfully';
import ModalGeneralFailed from 'screens/ModalGeneralFailed';
import { useMutation } from "@apollo/client";
import { APPLY_COUPON_TO_GROUP } from "graphql/service";
import { Head, Container, Footer } from './styles';

const ModalCouponCode = ({
  hidden,
  buttonStyle,
  groupId,
  setBill
}) => {

  const inputRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus()
        }
      }, 50)
      return () => clearTimeout(timer)
    }
  }, [isOpen])

  const [successfullyIsOpen, setSuccessfullyIsOpen] = useState(false)
  const [failedIsOpen, setFailedIsOpen] = useState(false)
  const [couponCode, setCouponCode] = useState("");
  const [couponError, setCouponError] = useState(false);

  const [applyCouponToGroup, { loading }] = useMutation(APPLY_COUPON_TO_GROUP, {
    onCompleted: (data) => {
      setBill(data.updateGroup.bills[0] || {})
      setSuccessfullyIsOpen(true)
      setFailedIsOpen(false)
      setIsOpen(false)
    },
    onError: (error) => {
      setFailedIsOpen(true)
      setIsOpen(false)
    }
  });

  const handleApplyCoupon = () => {
    if (loading) return;
    if (couponCode) {
      applyCouponToGroup({
        variables: {
          input: {
            groupId,
            couponCode: couponCode.toUpperCase(),
          },
        },
      });
    } else {
      setCouponError(true);
    }
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        buttonLabel="Coupon Code"
        buttonStyle={buttonStyle}
        hidden={hidden}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            .close {
              z-index: 200;
            }
            .modal-body {
              height: 100%;
              padding: 24px;
            }
          }
          top: 139px;
        `}
      >
        <Head>Coupon Code</Head>
        <Container>
          <Input
            inputFieldRef={inputRef}
            placeholder="Enter coupon code"
            title="ENTER A COUPON CODE"
            error={couponError}
            value={couponCode}
            onChange={(e) => {
              setCouponCode(e.target.value);
              setCouponError(false);
            }}
            additionalstyle={`
              flex-basis: 100%;
            `}
          />
        </Container>
        <Footer>
          <Button
            success
            onClick={handleApplyCoupon}
            data-loading={loading}
            additionalstyle={`
              width: 68px;
              margin-left: 16px;
            `}
          >
            {loading ? null : "Apply"}
          </Button>
        </Footer>
      </MainModal>
      <ModalGeneralSuccessfully
        isOpen={successfullyIsOpen}
        setIsOpen={setSuccessfullyIsOpen}
        type='coupon'
      />
      <ModalGeneralFailed
        isOpen={failedIsOpen}
        setIsOpen={setFailedIsOpen}
        loading={loading}
        retryFunction={handleApplyCoupon}
        type='coupon'
      />
    </>
  );
}

export default ModalCouponCode;
